import { css } from '@emotion/react';
import { Stack, Typography } from '@mui/material';
import { DescribedRadioGroup } from '../../../components/DescribedRadioGroup/DescribedRadioGroup';
import {
  KpiResolutionStrategyEntry,
  KpiSourceResolutionStrategy,
} from '../../../data-models/kpi-source-hierarchy.data-model';
import { cardBorderStyles } from '../../../theme/component-styles';

// Same chrome as the source rows below it, so the choice reads as part of the same list.
const pickerCss = css({
  ...cardBorderStyles,
  padding: '0.5rem 0.75rem 0.75rem',
  background: 'var(--mui-palette-background-paper)',
});

interface KpiResolutionStrategyPickerProps {
  strategies: KpiResolutionStrategyEntry[];
  value: KpiSourceResolutionStrategy;
  onChange: (strategy: KpiSourceResolutionStrategy) => void;
}

/** One radio per strategy the API offers, in the order it ships them (default first). */
export function KpiResolutionStrategyPicker({
  strategies,
  value,
  onChange,
}: KpiResolutionStrategyPickerProps) {
  return (
    <Stack css={pickerCss} rowGap='0.25rem'>
      <Typography variant='body2' fontWeight={500}>
        How a value is chosen
      </Typography>
      <DescribedRadioGroup
        ariaLabel='How a value is chosen'
        options={strategies.map((strategy) => ({
          value: strategy.id,
          label: strategy.label,
          description: strategy.description,
        }))}
        value={value}
        onChange={onChange}
      />
    </Stack>
  );
}
